import type { ExamBankMyResults, ExamKind } from '../../api/types';

export const KIND_LABEL: Record<ExamKind, string> = { exam: 'Exam', worksheet: 'Worksheet', homework: 'Homework' };

/** The viewer's own students on a bank item; nobody else's figures ever reach the bank. */
export function myResultsText(r: ExamBankMyResults): string {
  if (r.took === 0) return 'No results from your students';
  const avg = r.avg_score == null ? '' : ` · average ${Math.round(r.avg_score)}%`;
  return `${r.took} of your students took it${avg}`;
}

/** Where a fresh copy opens: worksheets and homework in the worksheet editor, exams on their page. */
export function copyDestination(copy: { id: number; kind: string }): string {
  return copy.kind === 'exam' ? `/exams/exam-detail/${copy.id}` : `/worksheets/${copy.id}/edit`;
}
